"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const assets_1 = require("../../api/assets");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/assets/configuration"));
class OfferStore {
    api = new assets_1.SoftwareOffersApi(configuration_1.default);
    internalOffers = [];
    loading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalOffers: mobx_1.observable,
            loading: mobx_1.observable,
            isLoading: mobx_1.computed,
            offers: mobx_1.computed,
            productNumbers: mobx_1.computed,
        });
    }
    get isLoading() {
        return this.loading;
    }
    get offers() {
        return this.internalOffers;
    }
    get productNumbers() {
        return Array.from(new Set(this.offers
            .map((offer) => offer.items?.map((offerItem) => offerItem.productId))
            .flat()
            .filter((productNumber) => !!productNumber)));
    }
    readOffers() {
        if (!AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.OFFER_READ) || this.loading) {
            return Promise.resolve(this.internalOffers);
        }
        this.loading = true;
        return this.api
            .readSoftwareOffers()
            .then((0, mobx_1.action)((offers) => (this.internalOffers = offers)))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
exports.default = new OfferStore();
